<div *ngIf="error">
  {{ error }}
</div>
<form [formGroup]="form" (submit)="onSubmit()">
  <div class="input-group">
    <mat-form-field>
      <input
        matInput
        type="text"
        class="input-wide"
        placeholder="Tenant Name"
        formControlName="name"
      />
      <p *ngIf="nameControl.dirty && nameControl.hasError('required')">
        {{ "tenants.required.name" | translate }}
      </p>
    </mat-form-field>
  </div>
  <div class="input-group">
    <mat-form-field>
      <input
        matInput
        type="text"
        class="input-wide"
        placeholder="Tenant ID"
        formControlName="id"
        [pattern]="urlSlugPattern"
        [readonly]="mode === FormMode.EDIT"
      />
      <p *ngIf="idControl.dirty && idControl.hasError('pattern')">
        {{ "tenants.invalidSlug" | translate }}
      </p>
      <p *ngIf="idControl.dirty && idControl.hasError('required')">
        {{ "tenants.required.id" | translate }}
      </p>
    </mat-form-field>
  </div>
  <div class="input-group">
    <mat-form-field>
      <mat-label>Country</mat-label>
      <mat-select formControlName="country">
        <mat-optgroup
          label="{{ 'settings.phone.commonCountryCodes' | translate }}"
          *ngIf="(preferredCountries$ | async).length > 0"
        >
          <mat-option
            *ngFor="let preferred of preferredCountries$ | async"
            [value]="countryCodeData[preferred].key"
          >
            {{ countryCodeData[preferred].key | countryFlag }}
            {{ countryCodeData[preferred].name }}
          </mat-option>
        </mat-optgroup>
        <mat-optgroup
          label="{{ 'settings.phone.allCountryCodes' | translate }}"
        >
          <mat-option
            *ngFor="let countryCode of countryCodeList"
            [value]="countryCodeData[countryCode].key"
          >
            {{ countryCodeData[countryCode].key | countryFlag }}
            {{ countryCodeData[countryCode].name }}
          </mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="input-group">
    <mat-slide-toggle formControlName="enabled">{{
      "tenants.enabled" | translate
    }}</mat-slide-toggle>
    <p *ngIf="form.get('enabled').value === false">
      {{ "tenants.disabled.description" | translate }}
    </p>
  </div>
  <div class="button-group">
    <button
      *ngIf="!_readOnly"
      [disabled]="
        loading || idControl.errors != null || nameControl.errors != null
      "
      role="button"
      color="primary"
      (click)="onSubmit()"
      mat-flat-button
    >
      {{
        (mode === FormMode.CREATE ? "tenants.create" : "tenants.save")
          | translate
      }}
    </button>
  </div>
</form>
